import React from 'react';
import Button from 'react-bootstrap/Button';
import ActionPanel from '../../components/action-panel-modal/action-panel';
import successIcon from '../../assets/img/template-confirmation-icon.svg'
import { useHistory } from 'react-router-dom';

const ConfirmationModal = ({ show, onHide, redirectURL, header, confirmationText }) => {
    let history = useHistory();
    const button1 = <Button onClick={() => history.push(redirectURL)}>Ok</Button>
    return (
        <ActionPanel
            show={show}
            onHide={onHide}
            header={header || "Save Confirmation"}
            icon={successIcon}
            mainText={confirmationText || "Your changes have been saved successfully."}
            acceptButton={button1}
        />
    )
}

export default ConfirmationModal;
